
<t4-header icon="glyphicon-stats" title="{{'T4.ServiceGuyItem.lblheader' |translate : 'Create Item' }}">
    <button mat-button type="button" color="primary" matTooltip="" (click)="createItem()" style="margin-left: 10px; float: left;" class="btn btn-default"><mat-icon>create</mat-icon>&nbsp;{{ 'T4.Campaign.createCampaign.lblcreate' | translate : 'Create'}}</button>
    <br />
</t4-header>

<t4-container title="{{ 'T4.Service.ServiceGuyItems.Headline' | translate : 'Service Persons items' }}">

  <t4-data-table #tblServiceGuy [allowFilter]="true" [rawData]="listOfServiceGuyItems" [allowExcel]="false" headline="{{'T4.Service.InventoryStaus.Headline' | translate : 'Inventory status' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['ItemId', 'Name']">

    <ng-container matColumnDef="Icon">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:60px; max-height:50px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 60px; max-height: 50px;" [ngClass]="{itemlow: row.LowItems > 0}">
        <button mat-icon-button (click)="update(row)">
          <mat-icon style="transform: rotate(90deg);">search</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ItemId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px; max-height:50px;">{{'T4.Service.ServiceGuyItems.ItemId' |translate : 'Item ID' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; min-height: 100px; max-height: 50px;">{{ row.ItemId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; max-height: 50px;">{{'T4.Service.ServiceGuyItems.Name' |translate : 'Item name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; min-height: 100px; max-height: 50px;">{{ row.Name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Delete">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <button mat-icon-button (click)="deleteItem(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

  </t4-data-table>

</t4-container>

